import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const AppToast = () => {
  return (
    <ToastContainer
      position='top-right'
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      pauseOnHover
      draggable
      theme='colored'
      toastStyle={{ fontFamily: 'Inter, Helvetica, "sans-serif"', fontSize: '15px' }}
    />
  )
}

export default AppToast
